export default __webpack_public_path__ + "static/media/db-logo-long.7dbb895e.svg";